export const emailNotificationInterval = {
  heading: "Email frequency updated!",
  BIWEEKLY: "You have successfully changed your email updates to biweekly.",
  WEEKLY: "You have successfully changed your email updates to weekly.",
  NONE: "You have successfully changed your email updates. We will only notify you if we find a match.",
};
